import React from 'react';
import './NextPiece.css';

const NextPiece = ({ tetromino }) => {
  if (!tetromino) return null;

  return (
    <div className="next-piece-container">
      <h3>다음 블록</h3>
      <div className="next-piece-board">
        {tetromino.shape.map((row, y) => (
          <div key={y} className="next-piece-row">
            {row.map((cell, x) => (
              <div
                key={x}
                className="next-piece-cell"
                style={{
                  backgroundColor: cell ? tetromino.color : 'transparent'
                }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NextPiece;
